






































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Lesson } from "@/types/MyLessons.js";
import { Action } from "vuex-class";

import LessonIcon from "./lessonIcon.vue";
import { source, refreshAxiosCancelToken } from "@/store/actions";

import { getDomain } from "@/auth";
import amplitude from "amplitude-js";
import consts from "../../consts";

@Component({
  components: { LessonIcon },
})
export default class UserLessons extends Vue {
  @Prop() public lesson!: Lesson;
  private selectedIDx: number = 0;
  private hoverEx: number = -1;
  @Action private resetState: any;
  private $amplitude: any;

  private created() {
    // Setup amplitude
    // source.cancel();
    // let domain = getDomain(window.location.href) as string | undefined;
    // this.$cookies.remove("ORAI_AUTH", "/", domain);
    // this.$cookies.remove(consts.currentLearnerTeam, "/", domain);
    // localStorage.clear();
    // this.resetState();
    // refreshAxiosCancelToken();
    // amplitude.getInstance().init(consts.amplitudeKey, "", {
    //   saveEvents: true,
    //   includeUtm: true,
    //   includeReferrer: true,
    // });
    // this.$amplitude = amplitude.getInstance();
  }

  private openExercise() {
    source.cancel();
    refreshAxiosCancelToken();
    this.$router.push({
      name: "exercise",
      params: {
        eid: String(this.lesson.Exercises[this.selectedIDx].ID),
        lid: String(this.lesson.ID),
      },
    });
    // this.$router.push({ name: "next-page", params: { foo: 1 } });
    // this.$router.push({ name: "team", params: { teamID: this.lesson } });
  }
}
